var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenderFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3300",
    "data-name": "Group 3300",
    transform: "translate(-1397 -1189)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3018",
    "data-name": "Rectangle 3018",
    width: 23,
    height: 23,
    transform: "translate(1397 1189)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component_9_6",
    "data-name": "Component 9 \\u2013 6",
    transform: "translate(1414.057 1209.096) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M480,96h1.537v8.79H480Z",
    transform: "translate(-475.24 -96.675)",
    fill: "#ba0b69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M293.528,491.057a5.528,5.528,0,1,1,5.528-5.528A5.6,5.6,0,0,1,293.528,491.057Zm0-9.477a3.949,3.949,0,1,0,3.949,3.949A3.911,3.911,0,0,0,293.528,481.579Z",
    transform: "translate(-288 -472.961)",
    fill: "#ba0b69"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3016",
    "data-name": "Rectangle 3016",
    width: 9,
    height: 2,
    transform: "translate(1.057 3.096)",
    fill: "#ba0b69"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderFemale);
export default __webpack_public_path__ + "static/media/gender_female.abffe677b28ef8d6c54807923245d6db.svg";
export { ForwardRef as ReactComponent };